// Nutrition Accordion JavaScript

document.addEventListener('DOMContentLoaded', function() {
  initNutritionAccordion();
});

function initNutritionAccordion() {
  // Accordion functionality
  const accordionHeaders = document.querySelectorAll('.nutrition-info .accordion-header');
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const accordionItem = this.closest('.accordion-item');
      const isActive = accordionItem.classList.contains('active');
      
      // Close all accordion items
      const allItems = document.querySelectorAll('.nutrition-info .accordion-item');
      allItems.forEach(item => {
        item.classList.remove('active');
      });
      
      // Toggle current item
      if (!isActive) {
        accordionItem.classList.add('active');
      }
    });
  });

  // Flavour tab functionality
  const flavourTabBtns = document.querySelectorAll('.nutrition-info .flavour-tab-btn');
  
  flavourTabBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent accordion from closing
      
      const targetId = this.getAttribute('data-target');
      const accordionItem = this.closest('.accordion-item');
      
      // Remove active class from all tabs in this accordion item
      const tabs = accordionItem.querySelectorAll('.flavour-tab-btn');
      tabs.forEach(tab => tab.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');
      
      // Hide all tab contents in this accordion item
      const contents = accordionItem.querySelectorAll('.flavour-tab-content');
      contents.forEach(content => content.classList.remove('active'));
      
      // Show target content
      const targetContent = accordionItem.querySelector(`#${targetId}`);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
}
